/* Widget de bundle — comportamento.

   O que ele NÃO faz: calcular desconto. Quem desconta é o desconto automático
   BXGY nativo da loja. O widget só escolhe a barra, resolve as variantes e
   adiciona a quantidade certa. Vitrine e checkout nunca divergem porque a conta
   é uma só, e é a do Shopify.

   As opções saem das VARIANTES REAIS, não de options_with_values: combinação que
   não existe faria o add falhar em silêncio. Esgotada aparece desabilitada. */
(function () {
  'use strict';

  function rotasCarrinho() {
    var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    /* sempre com .js — /cart/add sem extensão redireciona pra HTML */
    return { add: raiz + 'cart/add.js', get: raiz + 'cart.js' };
  }

  function ligar(raiz) {
    var variantes;
    try {
      variantes = JSON.parse(raiz.querySelector('[data-luv-variantes]').textContent);
    } catch (e) { return; }
    if (!variantes || !variantes.length) return;

    /* mapa cor -> hex, extraído do app e guardado no metafield */
    var swatches = (function () {
      var el = raiz.querySelector('[data-luv-swatches]');
      try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; }
    })();

    var barras = [].slice.call(raiz.querySelectorAll('[data-luv-barra]'));

    /* O botão de compra é o QUE A PÁGINA JÁ TEM.

       A referência não põe botão dentro do bloco de oferta: quem adiciona é o
       botão da página, já estilizado com a cor da marca. Renderizar mais um
       dava DOIS botões na tela — o da página, certo, e o meu logo acima, sem
       estilo (o CSS base do page-builder zera `button`). Aqui o botão da
       página é adotado e o de reserva, removido.

       A busca é por posição, não por classe solta: a página tem outros botões
       de compra (os "Acheter Maintenant" lá embaixo), e o certo é o primeiro
       que vem DEPOIS do widget no documento. */
    function botaoDaPagina() {
      var candidatos = [].slice.call(document.querySelectorAll(
        '.gp-button-atc, .product-form__submit, [name="add"]'));
      var depois = candidatos.filter(function (b) {
        if (raiz.contains(b)) return false;
        var r = b.getBoundingClientRect();
        if (r.width < 200) return false;              // os pequenos são outros
        return !!(raiz.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING);
      });
      return depois[0] || null;
    }

    var reserva = raiz.querySelector('[data-luv-add]');
    var daPagina = botaoDaPagina();
    var botao = daPagina || reserva;
    if (daPagina && reserva) reserva.remove();
    var textoBotao = (botao && botao.querySelector('[data-luv-add-texto]')) ||
                     raiz.querySelector('[data-luv-add-texto]') || null;
    var erro = raiz.querySelector('[data-luv-erro]');
    if (!barras.length || !botao) return;

    function escolhida() {
      return raiz.querySelector('.luv-bundle__barra.is-escolhida') || barras[0];
    }

    /* Encadeia as opções da esquerda pra direita: cada seletor só oferece o que
       EXISTE dado o que já foi escolhido antes dele. */
    function refazerOpcoes(unidade) {
      var selects = [].slice.call(unidade.querySelectorAll('[data-luv-opcao]'));
      selects.forEach(function (sel, nivel) {
        var anteriores = selects.slice(0, nivel).map(function (s) { return s.value; });
        var possiveis = [];
        variantes.forEach(function (v) {
          var bate = anteriores.every(function (val, i) { return v.opcoes[i] === val; });
          if (bate && possiveis.indexOf(v.opcoes[nivel]) === -1) possiveis.push(v.opcoes[nivel]);
        });
        var atual = sel.value;
        sel.innerHTML = '';
        possiveis.forEach(function (val) {
          var o = document.createElement('option');
          o.value = val;
          var combo = anteriores.concat([val]);
          var existe = variantes.some(function (v) {
            return combo.every(function (x, i) { return v.opcoes[i] === x; }) && v.disponivel;
          });
          o.textContent = existe ? val : val + ' (épuisé)';
          o.disabled = !existe;
          sel.appendChild(o);
        });
        if (possiveis.indexOf(atual) !== -1) sel.value = atual;
        else {
          var primeira = [].slice.call(sel.options).find(function (o) { return !o.disabled; });
          if (primeira) sel.value = primeira.value;
        }
      });
    }

    /* Pinta a bolinha com o hex da cor escolhida. O mapa vem do metafield
       (extraído do próprio app), então cor sem hex cadastrado simplesmente não
       pinta — nunca se adivinha uma cor a partir do nome dela. */
    /* Mede a largura de um texto na fonte real do campo. Um <canvas> resolve
       isso sem inserir nada no documento e sem forçar recálculo de layout. */
    var medirTexto = (function () {
      var ctx = document.createElement('canvas').getContext('2d');
      return function (texto, el) {
        var c = getComputedStyle(el);
        ctx.font = c.fontWeight + ' ' + c.fontSize + ' ' + c.fontFamily;
        return ctx.measureText(texto).width;
      };
    })();

    function pintarSwatches(unidade) {
      [].slice.call(unidade.querySelectorAll('.luv-bundle__campo.tem-cor')).forEach(function (campo) {
        var bola = campo.querySelector('[data-luv-swatch]');
        var sel = campo.querySelector('[data-luv-opcao]');
        if (!bola || !sel) return;
        bola.style.background = swatches[sel.value] || 'transparent';

        /* A caixa de cor da referência mede pelo valor ESCOLHIDO:
           7 de recheio + 16 da bolinha + 10 de vão + o texto + 25 à direita.
           Um <select> nativo mede pela opção MAIS LARGA — com "Violet clair"
           no meio das opções, o campo saía 40px mais largo que o de lá.
           A largura vai com `important` porque a regra de largura do widget
           também é `important` (o tema força 100% em select). */
        var l = Math.ceil(58 + medirTexto(sel.value, sel));
        sel.style.setProperty('width', l + 'px', 'important');
      });
    }

    function varianteDe(unidade) {
      var vals = [].slice.call(unidade.querySelectorAll('[data-luv-opcao]'))
        .map(function (s) { return s.value; });
      return variantes.find(function (v) {
        return vals.every(function (x, i) { return v.opcoes[i] === x; });
      });
    }

    function selecionar(barra) {
      barras.forEach(function (b) {
        var ativa = b === barra;
        b.classList.toggle('is-escolhida', ativa);
        b.setAttribute('aria-checked', ativa ? 'true' : 'false');
      });
      [].slice.call(barra.querySelectorAll('[data-luv-unidade]')).forEach(function (u) {
        refazerOpcoes(u); pintarSwatches(u);
      });
      if (erro) { erro.hidden = true; erro.textContent = ''; }
    }

    barras.forEach(function (b) {
      b.addEventListener('click', function () { selecionar(b); });
      b.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); selecionar(b); }
      });
      b.addEventListener('change', function (e) {
        if (e.target.matches('[data-luv-opcao]')) {
          var u = e.target.closest('[data-luv-unidade]');
          refazerOpcoes(u); pintarSwatches(u);
        }
      });
    });

    /* A rotina de adicionar, separada do botão que a dispara: quem chama passa
       os itens e o botão que deve ficar ocupado. É o que permite o botão
       principal e os "Acheter Maintenant" dos cartões usarem o MESMO caminho —
       mesma rota, mesma gaveta, mesmo tratamento de erro. */
    function adicionar(itens, disparador) {
      if (!itens || !itens.length) return;
      var rotas = rotasCarrinho();
      var rotulo = (disparador && disparador.querySelector('[data-luv-add-texto]')) ||
                   (disparador === botao ? textoBotao : null);
      var antes = rotulo ? rotulo.textContent : null;
      if (disparador) disparador.disabled = true;
      if (rotulo) rotulo.textContent = 'Ajout…';

      fetch(rotas.add, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        /* pede as seções da gaveta no mesmo pedido: evita uma ida a mais */
        body: JSON.stringify({ items: itens, sections: 'cart-drawer,cart-icon-bubble' })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) {
            if (erro) { erro.hidden = false; erro.textContent = res.j.description || res.j.message || 'Erreur'; }
            return;
          }
          abrirGaveta(res.j);
        })
        .catch(function () {
          if (erro) { erro.hidden = false; erro.textContent = 'Erreur de connexion.'; }
        })
        .then(function () {
          if (disparador) disparador.disabled = false;
          if (rotulo && antes !== null) rotulo.textContent = antes;
        });
    }

    botao.addEventListener('click', function (ev) {
      /* o botão da página pode estar dentro de um <form>: sem isto o clique
         submete o formulário e a página recarrega antes do nosso add */
      ev.preventDefault();
      ev.stopPropagation();
      var barra = escolhida();
      var unidades = [].slice.call(barra.querySelectorAll('[data-luv-unidade]'));
      var itens = [];
      /* Produto de variante única não tem seletor nenhum — e sem seletor não há
         elemento de unidade pra percorrer. A quantidade vem então do atributo da
         própria barra, que já traz quantas unidades a oferta leva. */
      if (!unidades.length) {
        var unica = variantes[0];
        if (!unica || !unica.disponivel) {
          if (erro) { erro.hidden = false; erro.textContent = 'Produit indisponible.'; }
          return;
        }
        itens.push({ id: unica.id, quantity: parseInt(barra.getAttribute('data-unidades'), 10) || 1 });
      }
      for (var i = 0; i < unidades.length; i++) {
        var v = varianteDe(unidades[i]);
        if (!v || !v.disponivel) {
          if (erro) { erro.hidden = false; erro.textContent = 'Cette combinaison n’est plus disponible.'; }
          return;
        }
        itens.push({ id: v.id, quantity: 1 });
      }
      adicionar(itens, botao);
    });

    /* Os "Acheter Maintenant" dos cartões de avaliação.

       Na origem cada cartão é um <form action="/cart/add"> com o próprio botão
       de submit, e clicar adiciona UMA unidade do produto — comprovado ao vivo
       (carrinho 0 -> 1, sem sair da página). A esteira desembrulha esse
       formulário, porque ele carrega o id de variante DA LOJA DE ORIGEM
       gravado no HTML; sem o formulário, o botão fica mudo.

       Aqui eles voltam a funcionar pelo mesmo caminho do botão principal, com
       a variante VIVA: a que estiver escolhida no widget ou, se ainda não
       houver escolha, a primeira disponível de verdade. */
    function ligarBotoesDeCartao() {
      [].slice.call(document.querySelectorAll('.gp-button-atc')).forEach(function (b) {
        if (b === botao || raiz.contains(b) || b.dataset.luvLigado) return;
        b.dataset.luvLigado = '1';
        b.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          var unidade = raiz.querySelector('.luv-bundle__barra.is-escolhida [data-luv-unidade]');
          var v = unidade ? varianteDe(unidade) : null;
          if (!v || !v.disponivel) {
            v = variantes.filter(function (x) { return x.disponivel; })[0];
          }
          if (!v) return;
          adicionar([{ id: v.id, quantity: 1 }], b);
        });
      });
    }
    ligarBotoesDeCartao();

    /* estado inicial: monta as opções da barra pré-escolhida */
    selecionar(escolhida());
  }

  /* Abre a gaveta do tema. NÃO confiar no renderContents do Dawn pra re-render
     externo: ele espera identificadores de seção próprios e pode devolver a
     gaveta vazia. Caminho confiável: buscar as seções e trocar o <cart-drawer>
     INTEIRO — o custom element novo se inicializa sozinho ao entrar no documento. */
  function abrirGaveta(resposta) {
    var gaveta = document.querySelector('cart-drawer');
    if (!gaveta) { window.location = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; return; }

    function trocarEabrir(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var nova = doc.querySelector('cart-drawer');
      if (nova) {
        gaveta.replaceWith(nova);
        gaveta = nova;
      }
      var bolha = doc.querySelector('#cart-icon-bubble');
      var alvoBolha = document.querySelector('#cart-icon-bubble');
      if (bolha && alvoBolha) alvoBolha.replaceWith(bolha);
      setTimeout(function () { if (gaveta.open) gaveta.open(); }, 60);
    }

    var secoes = resposta && resposta.sections;
    if (secoes && secoes['cart-drawer']) {
      trocarEabrir(secoes['cart-drawer'] + (secoes['cart-icon-bubble'] || ''));
      return;
    }
    var raiz = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    fetch(raiz + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) { trocarEabrir((s['cart-drawer'] || '') + (s['cart-icon-bubble'] || '')); })
      .catch(function () { window.location = raiz + 'cart'; });
  }

  /* O widget nasce escondido no fim do <body> (injetado pelo layout) e vem pro
     lugar certo aqui. Fazer assim evita reescrever os templates de produto um a
     um, e funciona igual na PDP nativa do Dawn e nas de page-builder.
     Âncoras, na ordem: o botão de compra do tema, o formulário, a área de info. */
  function posicionar(widget) {
    /* Encaixe deixado pelo conversor no lugar exato do bloco do app na PDP
       replicada. Ele vem PRIMEIRO: o widget herda posição e largura da
       referência, em vez de a gente escolher um tamanho no olho. */
    var encaixe = document.querySelector('[data-luv-bundle-slot]');
    if (encaixe) {
      encaixe.appendChild(widget);
      esconderNativo();
      return true;
    }
    /* PDP nativa do tema: âncoras conhecidas, da mais precisa pra mais geral */
    var alvos = [
      '.product-form__buttons',
      'product-form',
      '.product-form',
      '.product__info-container .price',
      '.product__info-container'
    ];
    for (var i = 0; i < alvos.length; i++) {
      var ancora = document.querySelector(alvos[i]);
      if (!ancora) continue;
      ancora.parentNode.insertBefore(widget, ancora);
      /* a referência tem UMA caixa de compra. Com a nativa junto, a página
         mostraria dois botões e dois seletores. */
      esconderNativo();
      return true;
    }
    return false;
  }

  /* O que some da caixa nativa quando o widget entra: os SELETORES, que o
     widget passa a oferecer por unidade. O BOTÃO fica — na PDP nativa é ele
     que a referência usa pra adicionar, e é ele que o widget adota. Escondendo
     o botão, a página perdia o visual do tema e passava a mostrar o botão de
     reserva do widget, que a referência não tem. */
  function esconderNativo() {
    ['variant-selects', '.product-form__input--pill',
     '.product-form__input--dropdown'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (e) {
        if (e.closest('[data-luv-bundle]')) return;
        e.style.display = 'none';
      });
    });
  }

  function iniciar() {
    var origem = document.getElementById('luv-bundle-origem');
    if (origem) {
      var widget = origem.querySelector('[data-luv-bundle]');
      if (widget && posicionar(widget)) origem.remove();
      else if (origem) origem.hidden = false;
    }
    document.querySelectorAll('[data-luv-bundle]').forEach(ligar);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
